import React, { useState, useEffect } from 'react';

// Components
import HeadStyle from './HeadStyle';
import PendingArchive from './PendingArchive';

const PendingArchiveContainer = ({
  event,
  match,
  loading,
  saveAuth,
  authorization,
  localData,
  branding,
}) => {
  const [brandingFound, setBrandingFound] = useState(false);

  useEffect(() => {
    setBrandingFound(branding);
  }, [branding]);

  return (
    <>
      {brandingFound ? <HeadStyle branding={brandingFound} /> : <HeadStyle />}
      <PendingArchive
        match={match}
        loading={loading}
        event={event}
        saveAuth={true}
        authorization={match.match.params.confirmationId}
        localData={localData}
        brandingFound={brandingFound}
      />
    </>
  );
};

export default React.memo(PendingArchiveContainer);
